/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_CompanyInputs */

const en_salary_negotiate_company = /** @type {(inputs: Salary_Negotiate_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const de_salary_negotiate_company = /** @type {(inputs: Salary_Negotiate_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen`)
};

const fr_salary_negotiate_company = /** @type {(inputs: Salary_Negotiate_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entreprise`)
};

const es_salary_negotiate_company = /** @type {(inputs: Salary_Negotiate_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresa`)
};

const it_salary_negotiate_company = /** @type {(inputs: Salary_Negotiate_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azienda`)
};

const nl_salary_negotiate_company = /** @type {(inputs: Salary_Negotiate_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrijf`)
};

const pl_salary_negotiate_company = /** @type {(inputs: Salary_Negotiate_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firma`)
};

const fi_salary_negotiate_company = /** @type {(inputs: Salary_Negotiate_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yritys`)
};

const da_salary_negotiate_company = /** @type {(inputs: Salary_Negotiate_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firma`)
};

const sv_salary_negotiate_company = /** @type {(inputs: Salary_Negotiate_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Företag`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Salary_Negotiate_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_company = /** @type {((inputs?: Salary_Negotiate_CompanyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_CompanyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_company(inputs)
	if (locale === "fr") return fr_salary_negotiate_company(inputs)
	if (locale === "es") return es_salary_negotiate_company(inputs)
	if (locale === "it") return it_salary_negotiate_company(inputs)
	if (locale === "nl") return nl_salary_negotiate_company(inputs)
	if (locale === "pl") return pl_salary_negotiate_company(inputs)
	if (locale === "fi") return fi_salary_negotiate_company(inputs)
	if (locale === "da") return da_salary_negotiate_company(inputs)
	if (locale === "sv") return sv_salary_negotiate_company(inputs)
	return en_salary_negotiate_company(inputs)
});